import OpenAI from 'openai';

const apiKey = import.meta.env.VITE_OPENAI_API_KEY;

if (!apiKey || apiKey === 'sk-your-api-key') {
  console.warn('OpenAI API key not configured. AI features will be disabled.');
}

export const openai = new OpenAI({
  apiKey: apiKey || 'dummy-key',
  dangerouslyAllowBrowser: true
});

// Wrapper function to check if AI features are enabled
export const isAiEnabled = () => {
  return apiKey && apiKey !== 'sk-your-api-key';
};

// Safe wrapper for OpenAI calls
export const safeOpenAiCall = async <T>(
  operation: () => Promise<T>,
  fallback: T
): Promise<T> => {
  if (!isAiEnabled()) {
    console.warn('AI features are disabled. Using fallback response.');
    return fallback;
  }

  try {
    return await operation();
  } catch (error) {
    console.error('OpenAI API error:', error);
    return fallback;
  }
};